var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOpinion = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 25,
  viewBox: "0 0 26 25",
  fill: "#34B8B5",
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v20.161H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 25l3.545-7.258h-7.09z"
})));
export default SvgOpinion;